// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  env:'develop',
  production: false,
  bwApiUrl:"https://apis.bw.dip.dev.worldline-solutions.com",
  wpApiUrl:"https://api.wp.dip.dev.worldline-solutions.com",
  apiUrl2:"http://localhost:8080",
  keycloakUrl: "https://aas3.idp.iam.worldline-solutions.com/auth/",
  keycloakRealm: "DEV_DIP",
  keycloakClientId: "back-office",
  urlDatastudioCompro:"https://datastudio.google.com/embed/reporting/4e83e8e3-edfb-471d-8d79-45c4d65869c1/page/62IgC",
  urlDatastudioAttestation:"https://datastudio.google.com/embed/reporting/9c50e3b8-5b50-469f-a5a3-34de84bcad6f/page/62IgC"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
